module.exports = __webpack_public_path__ + "static/media/search-icon.c06b706f.svg";